import { render, staticRenderFns } from "./ChecklistsManagerWidget.vue?vue&type=template&id=0532eb86"
import script from "./ChecklistsManagerWidget.vue?vue&type=script&lang=js"
export * from "./ChecklistsManagerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports